import { colors, typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const BlobPopoverStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const BlobSectionTitleStyled = styled.h3`
  ${typography.bold[16]};
  margin: 0 0 0.5rem;
`;

export const BlobRowStyled = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
`;

export const BlobContactFieldsStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const BlobLabelStyled = styled.span`
  ${typography.regular[16]};
  color: ${colors.neutral[700]};
  overflow-wrap: break-word;
  width: 6rem;
`;

export const BlobValueStyled = styled.p`
  ${typography.regular[16]}
  margin: 0;
  overflow-wrap: break-word;
`;

export const BlobPlaceholderStyled = styled.p`
  ${typography.regular[16]}
  margin: 0;
  color: ${colors.neutral[500]};
`;
